import { create } from "zustand";

export const useGlobalStore = create((set) => ({
    isAuthenticated: false,
    user: null,
    userLogin: (user) => set({ isAuthenticated: true, user: user }),
    userLogout: () => set({ isAuthenticated: false, user: null }),
}));
